window.__efpReveal=1;
/* file: brand/eu-product.js — reveal + tabbed video, rebuilt from the EU page.
 *
 * Two behaviours, both measured from energy.ecoflow.com/eu rather than
 * invented:
 *
 * 1. REVEAL. Elements carrying .efp-ani-N start at opacity 0 / translateY(20px)
 *    and get .is-in when they enter the viewport. The transition itself lives
 *    in the stylesheet so the stagger (0s, .2s, .4s, .6s) is declarative.
 *
 * 2. TABBED VIDEO. The band the EU page calls "Maintenance" is NOT scroll
 *    pinned -- verified by scrolling 900px through it on the live site with no
 *    change to the active tab. It switches on CLICK: the chosen <video> gets
 *    .is-on and cross-fades over .3s, and the bar slides to the tab's own
 *    offset and width. Only the visible video is played, so a page with
 *    several of these never decodes more than one stream at a time.
 */
(function () {
  "use strict";
  var doc = document;

  /* ---- reveal --------------------------------------------------------- */
  var targets = doc.querySelectorAll('[class*="efp-ani"]');
  if (!("IntersectionObserver" in window)) {
    for (var i = 0; i < targets.length; i++) targets[i].classList.add("is-in");
  } else {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add("is-in");
        io.unobserve(e.target);
      });
    }, { rootMargin: "0px 0px -12% 0px", threshold: 0.08 });
    for (var j = 0; j < targets.length; j++) io.observe(targets[j]);

    /* The -12% bottom margin is what makes an element wait until it is
       properly on screen rather than peeking over the fold. It also means
       anything inside the last 12% of the FINAL screen can never intersect,
       because the page cannot scroll any further -- on this page that was the
       call to action itself, left permanently at opacity 0. Once the document
       is scrolled out, reveal whatever is still waiting. */
    var atEnd = function () {
      if (window.innerHeight + window.scrollY < doc.documentElement.scrollHeight - 2) return;
      for (var k = 0; k < targets.length; k++) {
        if (!targets[k].classList.contains("is-in")) {
          targets[k].classList.add("is-in");
          io.unobserve(targets[k]);
        }
      }
      window.removeEventListener("scroll", atEnd);
    };
    window.addEventListener("scroll", atEnd, { passive: true });
    window.addEventListener("resize", atEnd);
  }

  /* ---- tabbed video --------------------------------------------------- */
  Array.prototype.forEach.call(doc.querySelectorAll("[data-efp-tabsvid]"), function (root) {
    var tabs = root.querySelectorAll(".efp-tab");
    /* Two kinds of stage share this control: a video one and an image one.
       Querying only ".efp-tabsvid__stage video" matched nothing on the image
       bands, so the tab, the bar and the caption all updated while the
       picture never changed -- which reads as "the tab does nothing" rather
       than as a broken selector. */
    var vids = root.querySelectorAll(".efp-tabsvid__stage video, .efp-tabsimg__stage img");
    var bar = root.querySelector(".efp-tabs__bar");
    if (!tabs.length) return;

    function moveBar(tab) {
      if (!bar) return;
      bar.style.width = tab.offsetWidth + "px";
      bar.style.transform = "translateX(" + tab.offsetLeft + "px)";
    }
    function select(n) {
      Array.prototype.forEach.call(tabs, function (t, i) {
        t.setAttribute("aria-selected", i === n ? "true" : "false");
        if (i === n) moveBar(t);
      });
      /* The caption belongs to the active tab: the EU page shows exactly one
         of them at a time, under the stage. */
      Array.prototype.forEach.call(root.querySelectorAll(".efp-tabcap"), function (c) {
        c.classList.toggle("is-on", Number(c.getAttribute("data-cap")) === n);
      });
      Array.prototype.forEach.call(vids, function (v, i) {
        var isVideo = v.tagName === "VIDEO";
        if (i === n) {
          v.classList.add("is-on");
          if (isVideo) {
            /* the first switch is also the first time this source is wanted */
            if (v.preload === "none") { v.preload = "metadata"; v.load(); }
            var p = v.play(); if (p && p.catch) p.catch(function () {});
          }
        } else {
          v.classList.remove("is-on");
          if (isVideo) v.pause();
        }
      });
    }
    Array.prototype.forEach.call(tabs, function (t, i) {
      t.addEventListener("click", function () { select(i); });
    });

    /* Position the bar once the tab has its final width — a web font landing
       late re-measures the label, and a bar sized before that sits short. */
    function settle() { var on = root.querySelector('.efp-tab[aria-selected="true"]'); if (on) moveBar(on); }
    settle();
    if (doc.fonts && doc.fonts.ready && doc.fonts.ready.then) doc.fonts.ready.then(settle);
    window.addEventListener("resize", settle);

    /* Play the first video only once the band is actually on screen. */
    if ("IntersectionObserver" in window && vids.length) {
      var vio = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          var on = root.querySelector(".efp-tabsvid__stage video.is-on");
          if (!on) return;   /* an image stage has nothing to play */
          if (!on) return;
          if (e.isIntersecting) { var p = on.play(); if (p && p.catch) p.catch(function () {}); }
          else on.pause();
        });
      }, { threshold: 0.25 });
      vio.observe(root);
    }
  });
})();

/* ---- scene toggle ------------------------------------------------------
 * The chip's right icon swaps the scene between its two renders and swaps
 * its own icon with it. On the EU page this is a <div class="right-icon">
 * with cursor:pointer and no role, so a keyboard user cannot reach it; here
 * it is a real button carrying aria-pressed, which costs nothing and makes
 * the control operable. Both renders are in the DOM and cross-fade, so the
 * second one is not fetched at the moment of the click. */
(function () {
  "use strict";
  Array.prototype.forEach.call(document.querySelectorAll("[data-efp-scene]"), function (root) {
    var btn = root.querySelector(".efp-scene__toggle");
    var shots = root.querySelectorAll(".efp-scene__media img");
    var icons = btn ? btn.querySelectorAll("img") : [];
    if (!btn || shots.length < 2) return;
    var on = 0;
    btn.addEventListener("click", function () {
      on = on ? 0 : 1;
      btn.setAttribute("aria-pressed", on ? "true" : "false");
      Array.prototype.forEach.call(shots, function (im, i) { im.classList.toggle("is-on", i === on); });
      Array.prototype.forEach.call(icons, function (im, i) { im.classList.toggle("is-on", i === on); });
    });
  });
})();

/* ---- pinned sequence ---------------------------------------------------
 * Drives a sticky stage from scroll progress: cross-fades the step layers and,
 * on a video step, scrubs currentTime instead of playing.
 *
 * The video is fetched whole and attached as a blob URL, which is what the EU
 * page does -- its <video> src is a blob: and the underlying request is the
 * plain mp4. That matters: seeking a streamed file issues a range request per
 * frame and the scrub stutters, while a fully buffered blob seeks instantly.
 *
 * Scroll is read in a rAF loop rather than on every scroll event, so a
 * trackpad firing hundreds of events a second still costs one seek per frame.
 */
(function () {
  "use strict";
  var pins = document.querySelectorAll("[data-efp-pin]");
  if (!pins.length) return;

  Array.prototype.forEach.call(pins, function (root) {
    var layers = root.querySelectorAll(".efp-pin__layer");
    var texts = root.querySelectorAll(".efp-pin__text");
    var steps = layers.length;
    if (!steps) return;
    var vid = root.querySelector(".efp-pin__layer video");
    var vidStep = vid ? +vid.closest(".efp-pin__layer").getAttribute("data-step") : -1;
    var ticking = false, lastStep = -1;

    if (vid) {
      var real = vid.getAttribute("data-src");
      if (real) {
        fetch(real).then(function (r) { return r.blob(); }).then(function (bl) {
          vid.src = URL.createObjectURL(bl);
          vid.load();
        }).catch(function () { vid.src = real; vid.load(); });   /* streamed is better than absent */
      }
    }

    function frame() {
      ticking = false;
      var r = root.getBoundingClientRect();
      var travel = root.offsetHeight - window.innerHeight;
      if (travel <= 0) return;
      var p = Math.min(1, Math.max(0, -r.top / travel));

      /* The video step is worth TWO slices to each still's one. Measured on
         both pinned bands that scrub: three steps give stills 0-0.5 and the
         scrub 0.5-1 (0.25 each, video 0.5); four steps give stills 0-0.6 and
         the scrub 0.6-1 (0.2 each, video 0.4). So slices = (steps-1) + 2. */
      var step, within;
      if (vidStep >= 0 && steps > 1) {
        var each = 1 / ((steps - 1) + 2);
        var stillShare = each * (steps - 1);
        if (p < stillShare) { step = Math.min(steps - 2, Math.floor(p / each)); within = 0; }
        else { step = vidStep; within = (p - stillShare) / (1 - stillShare); }
      } else {
        step = Math.min(steps - 1, Math.floor(p * steps));
        within = p * steps - step;
      }

      if (step !== lastStep) {
        lastStep = step;
        Array.prototype.forEach.call(layers, function (l, i) { l.classList.toggle("is-on", i === step); });
        Array.prototype.forEach.call(texts, function (t, i) { t.classList.toggle("is-on", i === step); });
      }
      if (vid && step === vidStep && vid.readyState >= 1 && isFinite(vid.duration)) {
        var t = Math.min(vid.duration, Math.max(0, within * vid.duration));
        if (Math.abs(vid.currentTime - t) > 0.016) vid.currentTime = t;   /* ~1 frame */
      }
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(frame); } }
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    frame();
  });
})();

/* ---- accordion ---------------------------------------------------------
 * Exclusive panels, each swapping the image beside it. Height is animated
 * from the panel's own scrollHeight and then released to auto, so the open
 * panel still reflows if the text wraps differently after a font loads.
 */
(function () {
  "use strict";
  Array.prototype.forEach.call(document.querySelectorAll("[data-efp-acc]"), function (root) {
    var btns = root.querySelectorAll(".efp-acc2__btn");
    var panels = root.querySelectorAll(".efp-acc2__panel");
    var shots = root.querySelectorAll(".efp-acc2__media img");
    function open(n) {
      Array.prototype.forEach.call(btns, function (b, i) {
        b.setAttribute("aria-expanded", i === n ? "true" : "false");
      });
      Array.prototype.forEach.call(panels, function (p, i) {
        if (i === n) {
          p.hidden = false;
          p.style.height = p.scrollHeight + "px";
          /* release to auto once the transition is done, so later reflow works */
          var done = function () { p.style.height = "auto"; p.removeEventListener("transitionend", done); };
          p.addEventListener("transitionend", done);
        } else {
          p.style.height = p.scrollHeight + "px";   /* from a real number, or it cannot animate */
          void p.offsetHeight;
          p.style.height = "0px";
          p.hidden = true;
        }
      });
      Array.prototype.forEach.call(shots, function (im, i) { im.classList.toggle("is-on", i === n); });
    }
    Array.prototype.forEach.call(btns, function (b, i) {
      b.addEventListener("click", function () {
        open(b.getAttribute("aria-expanded") === "true" ? -1 : i);
      });
    });
    open(0);
  });
})();

/* ---- pin, shrink-to-reveal --------------------------------------------
 * The video plays once while its BOX is scaled down from full-bleed to a
 * contained card, which lifts the copy beneath it into view. Measured on the
 * EU: 1440x900 to 1280x570 across the first 90% of the track, with the clip
 * playing normally rather than scrubbed, and holding its last frame after.
 * Width and height are driven separately because the box changes aspect.
 */
(function () {
  "use strict";
  Array.prototype.forEach.call(document.querySelectorAll("[data-efp-zoom]"), function (root) {
    var box = root.querySelector(".efp-pin__box");
    var vid = root.querySelector(".efp-pin__box video");
    /* EU (visual audit 13OCT2026): the over-title fades 1 -> 0 across 0-75%
       of the track, and the copy under the box only arrives at ~85%. */
    var over = root.querySelector(".efp-pin__over"), under = root.querySelector(".efp-pin__under");
    if (!box) return;
    var played = false, ticking = false;

    if (vid) {
      var real = vid.getAttribute("data-src");
      if (real) {
        fetch(real).then(function (r) { return r.blob(); }).then(function (bl) {
          vid.src = URL.createObjectURL(bl); vid.load();
        }).catch(function () { vid.src = real; vid.load(); });
      }
    }
    function frame() {
      ticking = false;
      var r = root.getBoundingClientRect();
      var travel = root.offsetHeight - window.innerHeight;
      if (travel <= 0) return;
      var p = Math.min(1, Math.max(0, -r.top / travel));
      var k = Math.min(1, p / 0.9);                 /* settles by 90% of the track */
      var fullW = window.innerWidth, fullH = Math.min(900, window.innerHeight);
      var endW = Math.min(1280, fullW), endH = Math.round(fullH * 570 / 900);
      if (over) over.style.opacity = Math.max(0, 1 - p / 0.75).toFixed(3);
      if (under) under.classList.toggle("is-on", p >= 0.85);
      box.style.width  = Math.round(fullW + (endW - fullW) * k) + "px";
      box.style.height = Math.round(fullH + (endH - fullH) * k) + "px";
      if (vid && !played && p > 0.01 && vid.readyState >= 2) {
        played = true;
        var pr = vid.play(); if (pr && pr.catch) pr.catch(function () {});
      }
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(frame); } }
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    frame();
  });
})();

/* ---- the held stage ------------------------------------------------------
   One full-bleed video that plays once when the stage reaches the viewport.
   The source is attached on entry rather than in the markup, so a page with
   four of these does not fetch four videos before the hero has painted. */
(function () {
  var holds = document.querySelectorAll(".efp-pinhold[data-efp-play]");
  if (!holds.length) return;
  Array.prototype.forEach.call(holds, function (sec) {
    var vid = sec.querySelector("video");
    if (!vid) return;
    var started = false;
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting || started) return;
        started = true;
        var real = vid.getAttribute("data-src");
        if (real) { vid.src = real; vid.load(); }
        vid.addEventListener("loadeddata", function () {
          var pr = vid.play(); if (pr && pr.catch) pr.catch(function () {});
        }, { once: true });
        io.disconnect();
      });
    }, { rootMargin: "200px 0px" });
    io.observe(sec);
  });
})();

/* ---- the chapter rail ----------------------------------------------------
   The rail appears once the page has passed its first anchor and hides again
   at the last, and the dot for the band currently filling the viewport is
   marked. It reads scroll position rather than using IntersectionObserver
   because the anchored bands include 3150px pins: a pin is "intersecting"
   for three screens at a time, which marks two dots at once. */
(function () {
  var nav = document.querySelector("[data-efp-dotnav]");
  if (!nav) return;
  var items = Array.prototype.slice.call(nav.querySelectorAll(".efp-dotnav__i"));
  var targets = items.map(function (a) {
    return document.getElementById(a.getAttribute("data-target"));
  });
  if (targets.some(function (t) { return !t; })) { nav.remove(); return; }

  items.forEach(function (a, i) {
    a.addEventListener("click", function (e) {
      e.preventDefault();
      targets[i].scrollIntoView({
        behavior: matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth",
        block: "start"
      });
    });
  });

  var ticking = false;
  function frame() {
    ticking = false;
    var mid = window.scrollY + window.innerHeight / 2;
    var first = targets[0].getBoundingClientRect().top + window.scrollY;
    var last = targets[targets.length - 1];
    var end = last.getBoundingClientRect().bottom + window.scrollY;
    nav.classList.toggle("is-on", mid > first && mid < end);
    var active = -1;
    targets.forEach(function (t, i) {
      var top = t.getBoundingClientRect().top + window.scrollY;
      if (mid >= top) active = i;
    });
    items.forEach(function (a, i) { a.classList.toggle("is-on", i === active); });
  }
  function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(frame); } }
  window.addEventListener("scroll", onScroll, { passive: true });
  window.addEventListener("resize", onScroll);
  frame();
})();

/* ---- the opening act -----------------------------------------------------
   A line of type scales from 48px to roughly forty times that while the page
   scrolls, then hands over to a film whose playhead is tied to the scrollbar
   and four headlines that rise through it.

   The type is scaled with a transform, not by animating font-size: font-size
   relayouts the text on every frame, which on the EU's own page is what makes
   the first second of this stutter. */
(function () {
  var secs = document.querySelectorAll("[data-efp-textzoom]");
  if (!secs.length) return;
  Array.prototype.forEach.call(secs, function (sec) {
    var word = sec.querySelector(".efp-tz__word");
    var film = sec.querySelector(".efp-tz__film");
    var vid = sec.querySelector("video");
    var caps = sec.querySelectorAll(".efp-tz__cap");
    var ZOOM = 0.42;                 /* the type owns the first 42% of the track */
    var ticking = false, attached = false;

    function frame() {
      ticking = false;
      var travel = sec.offsetHeight - window.innerHeight;
      if (travel <= 0) return;
      var p = Math.min(1, Math.max(0, -sec.getBoundingClientRect().top / travel));

      if (p < ZOOM) {
        var k = p / ZOOM;
        word.style.transform = "scale(" + (1 + k * k * 39) + ")";
        word.style.opacity = String(1 - Math.max(0, (k - 0.82) / 0.18));
        film.classList.remove("is-on");
        /* Clear the headlines too. Scrolling back up left the last one still
           marked, so the film came back carrying the end of its own sequence. */
        for (var c = 0; c < caps.length; c++) caps[c].classList.remove("is-on");
      } else {
        word.style.opacity = "0";
        film.classList.add("is-on");
        if (!attached && vid) {
          attached = true;
          var real = vid.getAttribute("data-src");
          if (real) {
            vid.src = real;
            vid.load();
            /* Park the playhead at the start. A preloaded <video> sits on its
               LAST frame, which flashed for one frame as the film faded in. */
            vid.addEventListener("loadedmetadata", function () {
              try { vid.currentTime = 0; } catch (e) {}
            }, { once: true });
          }
        }
        var q = Math.min(0.9999, (p - ZOOM) / (1 - ZOOM));   /* the last headline holds to the end */
        if (vid && vid.readyState >= 1 && vid.duration) {
          try { vid.currentTime = Math.min(vid.duration - 0.05, q * vid.duration); } catch (e) {}
        }
        /* Each headline owns an equal slice and is on for the middle of it. */
        var n = caps.length, slice = 1 / n;
        for (var i = 0; i < n; i++) {
          var within = (q - i * slice) / slice;
          caps[i].classList.toggle("is-on", within >= 0 && within < 1);
        }
      }
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(frame); } }
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    frame();
  });
})();

/* ---- media that holds while the copy scrolls -----------------------------
   The step whose text block is nearest the middle of the screen is the live
   one; its picture is shown and its words come up to full strength. Where the
   band carries a video instead of a set of stills, the playhead follows the
   whole track rather than the step, because the EU scrubs it continuously. */
(function () {
  var secs = document.querySelectorAll("[data-efp-sticky]");
  if (!secs.length) return;
  Array.prototype.forEach.call(secs, function (sec) {
    var steps = sec.querySelectorAll(".efp-sm__step");
    var shots = sec.querySelectorAll(".efp-sm__shot");
    var vid = sec.querySelector(".efp-sm__media video");
    var box2 = sec.classList.contains("efp-sm--pincopy") && sec.classList.contains("efp-sm--box") ? sec : null;
    var hold = sec.classList.contains("efp-sm--hold");
    var ticking = false, attached = false;

    function frame() {
      ticking = false;
      var mid = window.innerHeight / 2, best = 0, bestD = Infinity;
      if (hold && window.innerWidth > 1024) {
        /* Held copy: all steps share one place, so the live one comes from
           progress through the pinned run, not from position on screen. */
        var ih = sec.querySelector(".efp-sm__inner"), run = ih.offsetHeight - window.innerHeight;
        var q = run > 0 ? Math.min(1, Math.max(0, -ih.getBoundingClientRect().top / run)) : 0;
        best = Math.min(steps.length - 1, Math.floor(q * steps.length));
      } else for (var i = 0; i < steps.length; i++) {
        var r = steps[i].getBoundingClientRect();
        var d = Math.abs(r.top + r.height / 2 - mid);
        if (d < bestD) { bestD = d; best = i; }
      }
      for (var j = 0; j < steps.length; j++) steps[j].classList.toggle("is-on", j === best);
      /* Fewer pictures than steps (the app band: one currency-free screen for
         both): the last picture stays up rather than leaving an empty frame. */
      for (var k = 0; k < shots.length; k++) shots[k].classList.toggle("is-on", k === Math.min(best, shots.length - 1));

      /* PowerInsight: the second photograph rises 300px into place over the
         first across the middle of the hold, as the EU's does. */
      if (box2) {
        var tr2 = sec.offsetHeight - window.innerHeight;
        if (tr2 > 0) {
          var q = Math.min(1, Math.max(0, -sec.getBoundingClientRect().top / tr2));
          box2.style.setProperty("--sm-k", Math.min(1, Math.max(0, (q - 0.1) / 0.55)).toFixed(3));
        }
      }
      if (vid) {
        /* Scrub over the pinned part only: the section also holds the trail
           band below the pin, and counting it left the film a third behind. */
        var inner = sec.querySelector(".efp-sm__inner");
        var travel = (inner ? inner.offsetHeight : sec.offsetHeight) - window.innerHeight;
        if (travel > 0) {
          var p = Math.min(1, Math.max(0, -sec.getBoundingClientRect().top / travel));
          if (!attached && p > -0.5) {
            attached = true;
            var real = vid.getAttribute("data-src");
            if (real) { vid.src = real; vid.load(); }
          }
          if (vid.readyState >= 1 && vid.duration) {
            try { vid.currentTime = Math.min(vid.duration - 0.05, p * vid.duration); } catch (e) {}
          }
        }
      }
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(frame); } }
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    frame();
  });
})();

/* ---- the cutaway's named parts ------------------------------------------ */
(function () {
  var secs = document.querySelectorAll("[data-efp-hotspots]");
  Array.prototype.forEach.call(secs, function (sec) {
    var pins = sec.querySelectorAll(".efp-hs__pin");
    Array.prototype.forEach.call(pins, function (pin) {
      pin.addEventListener("click", function () {
        var open = pin.getAttribute("aria-expanded") === "true";
        Array.prototype.forEach.call(pins, function (o) {
          o.setAttribute("aria-expanded", "false");
          var n = document.getElementById(o.getAttribute("aria-controls"));
          if (n) n.hidden = true;
        });
        if (open) return;
        pin.setAttribute("aria-expanded", "true");
        var note = document.getElementById(pin.getAttribute("aria-controls"));
        if (note) note.hidden = false;
      });
    });
  });
})();

/* ---- a looping film that plays only while it is on screen ----------------
   The older template's films are `autoplay loop`, but the EU holds each one
   paused until it scrolls in. The source is attached a screen early so the
   first frame is there on arrival, and nothing downloads on a page load that
   never reaches it. */
(function () {
  var vids = document.querySelectorAll(".efp-ft__media video[data-src]");
  if (!vids.length || !("IntersectionObserver" in window)) {
    Array.prototype.forEach.call(vids, function (v) { v.src = v.getAttribute("data-src"); v.autoplay = true; });
    return;
  }
  var near = new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      if (!e.isIntersecting) return;
      var v = e.target; near.unobserve(v);
      v.src = v.getAttribute("data-src"); v.load();
    });
  }, { rootMargin: "100% 0px" });
  var seen = new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      var v = e.target;
      if (e.isIntersecting) { var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); }
      else v.pause();
    });
  }, { threshold: 0.15 });
  Array.prototype.forEach.call(vids, function (v) { near.observe(v); seen.observe(v); });
})();

/* ---- the explainer behind a "Know more" pill ------------------------------
   A native <dialog>, so focus is trapped and Escape closes it for free; a
   click on the dimmed ground outside the card closes it too, as the EU's does. */
(function () {
  Array.prototype.forEach.call(document.querySelectorAll("[data-efp-more]"), function (btn) {
    var dlg = document.getElementById(btn.getAttribute("aria-controls"));
    if (!dlg || typeof dlg.showModal !== "function") return;
    var vid = dlg.querySelector("video[data-src]");
    btn.addEventListener("click", function () {
      dlg.showModal();
      /* A film is attached on first open and starts with sound: the click
         that opened it is the gesture that allows that. */
      if (vid) {
        if (!vid.getAttribute("src")) { vid.src = vid.getAttribute("data-src"); }
        var pr = vid.play(); if (pr && pr.catch) pr.catch(function () {});
      }
    });
    dlg.addEventListener("click", function (e) {
      if (e.target === dlg || e.target.closest("[data-efp-close]")) dlg.close();
    });
    dlg.addEventListener("close", function () { if (vid) vid.pause(); btn.focus(); });
  });
})();

/* ---- zoom-reveal ---------------------------------------------------------
   Timings are the EU's, as fractions of the track: label out 0-8%, zoom 4x
   to 1x across 12-37%, second photograph and copy in across 37-63%. */
(function () {
  var secs = document.querySelectorAll("[data-efp-zr]");
  if (!secs.length) return;
  var still = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  if (still) return;
  var clamp = function (x) { return Math.min(1, Math.max(0, x)); };
  Array.prototype.forEach.call(secs, function (sec) {
    var zoom = sec.querySelector(".efp-zr__zoom"), label = sec.querySelector(".efp-zr__label"),
        b = sec.querySelector(".efp-zr__b"), ticking = false;
    function frame() {
      ticking = false;
      var travel = sec.offsetHeight - window.innerHeight;
      if (travel <= 0) return;
      var p = clamp(-sec.getBoundingClientRect().top / travel);
      label.style.opacity = 1 - clamp(p / 0.08);
      zoom.style.transform = "scale(" + (4 - 3 * clamp((p - 0.12) / 0.25)).toFixed(4) + ")";
      b.style.opacity = clamp((p - 0.37) / 0.26).toFixed(3);
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(frame); } }
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    frame();
  });
})();

/* ---- card steps ----------------------------------------------------------
   n chapters over 2n-1 equal segments. Chapter i rises in across segment
   2i-1 and out across 2i (150px, opacity with it); its picture holds from
   the middle of its entry to the middle of the next one, switching outright
   as the EU's does. */
(function () {
  var secs = document.querySelectorAll("[data-efp-cs]");
  if (!secs.length) return;
  var flat = window.matchMedia && window.matchMedia("(max-width: 767px), (prefers-reduced-motion: reduce)");
  var clamp = function (x) { return Math.min(1, Math.max(0, x)); };
  Array.prototype.forEach.call(secs, function (sec) {
    var steps = sec.querySelectorAll(".efp-cs__step"), n = steps.length,
        seg = parseFloat(sec.getAttribute("data-seg")) || 1 / (2 * n - 1),
        ticking = false;
    function frame() {
      ticking = false;
      if (flat && flat.matches) return;
      var travel = sec.offsetHeight - window.innerHeight;
      if (travel <= 0) return;
      var p = clamp(-sec.getBoundingClientRect().top / travel);
      var on = Math.min(n - 1, Math.floor((p + seg) / (2 * seg)));
      for (var i = 0; i < n; i++) {
        var o = 1, y = 0;
        if (i > 0) { var e = clamp((p - (2 * i - 1) * seg) / seg); o = e; y = 150 * (1 - e); }
        if (i < n - 1) { var x = clamp((p - 2 * i * seg) / seg); if (x > 0) { o = 1 - x; y = -150 * x; } }
        var t = steps[i].querySelector(".efp-cs__txt");
        t.style.setProperty("--cs-o", o.toFixed(3));
        t.style.setProperty("--cs-y", y.toFixed(1) + "px");
        steps[i].classList.toggle("is-on", i === on);
      }
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(frame); } }
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    frame();
  });
})();

/* ---- pull-back -----------------------------------------------------------
   EU timings as fractions of the track: scale 1.44 to 1 across 0-22%, the
   headline in across 47-72% while rising 40px. */
(function () {
  var secs = document.querySelectorAll("[data-efp-pb]");
  if (!secs.length) return;
  if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
  var clamp = function (x) { return Math.min(1, Math.max(0, x)); };
  Array.prototype.forEach.call(secs, function (sec) {
    var zoom = sec.querySelector(".efp-pb__zoom"), h = sec.querySelector(".efp-pb__h"),
        mask = sec.querySelector(".efp-pb__mask"), ticking = false,
        zEnd = parseFloat(sec.getAttribute("data-zoom-end")) || 0.22,
        hFrom = parseFloat(sec.getAttribute("data-h-from")) || 0.47,
        hSpan = parseFloat(sec.getAttribute("data-h-span")) || 0.25;
    function frame() {
      ticking = false;
      var travel = sec.offsetHeight - window.innerHeight;
      if (travel <= 0) return;
      var p = clamp(-sec.getBoundingClientRect().top / travel), k = clamp((p - hFrom) / hSpan);
      zoom.style.transform = "scale(" + (1.44 - 0.44 * clamp(p / zEnd)).toFixed(4) + ")";
      h.style.opacity = k.toFixed(3);
      if (mask) mask.style.opacity = k.toFixed(3);
      h.style.setProperty("--pb-y", (40 * (1 - k)).toFixed(1) + "px");
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(frame); } }
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    frame();
  });
})();

/* ---- scrubbed film with timed captions -----------------------------------
   The playhead follows the track; `data-lead` starts it a fraction early,
   as the EU's does (it is already 12% in when the stage pins). Captions and
   the closing text switch at thresholds with a CSS transition, which is how
   the EU moves them: a window, not a curve. A phone gets the 4:3 cut. */
(function () {
  var secs = document.querySelectorAll("[data-efp-scrub]");
  if (!secs.length) return;
  var clamp = function (x) { return Math.min(1, Math.max(0, x)); };
  Array.prototype.forEach.call(secs, function (sec) {
    var vid = sec.querySelector("video"), caps = sec.querySelectorAll("[data-from]"),
        lead = parseFloat(sec.getAttribute("data-lead")) || 0,
        span = parseFloat(sec.getAttribute("data-span")) || 1, attached = false, ticking = false;
    function attach() {
      attached = true;
      var small = window.matchMedia && window.matchMedia("(max-width: 767px)").matches;
      var real = (small && vid.getAttribute("data-src-sm")) || vid.getAttribute("data-src");
      /* A blob seeks without a network round trip per frame. */
      fetch(real).then(function (r) { return r.blob(); }).then(function (bl) {
        vid.src = URL.createObjectURL(bl); vid.load();
      }).catch(function () { vid.src = real; vid.load(); });
    }
    function frame() {
      ticking = false;
      var r = sec.getBoundingClientRect(), travel = sec.offsetHeight - window.innerHeight;
      if (travel <= 0) return;
      if (!attached && r.top < window.innerHeight * 2) attach();
      var f = -r.top / travel;
      for (var i = 0; i < caps.length; i++) {
        var a = parseFloat(caps[i].getAttribute("data-from")),
            b = parseFloat(caps[i].getAttribute("data-to") || "9");
        caps[i].classList.toggle("is-on", f >= a && f < b);
        caps[i].classList.toggle("is-past", f >= b);
      }
      if (vid.readyState >= 1 && vid.duration) {
        try { vid.currentTime = Math.min(vid.duration - 0.03, clamp((f + lead) / span) * vid.duration); } catch (e) {}
      }
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(frame); } }
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    vid.addEventListener("loadedmetadata", frame);
    frame();
  });
})();

/* ---- "Typical Day of Savings", pinned --------------------------------------
   EU (visual audit 13OCT2026): the bar fills with progress through the hold
   and window i arrives at 15% x (i + 1). */
(function () {
  var secs = document.querySelectorAll("[data-efp-day]");
  if (!secs.length) return;
  var flat = window.matchMedia && window.matchMedia("(max-width: 767px), (prefers-reduced-motion: reduce)");
  Array.prototype.forEach.call(secs, function (sec) {
    var track = sec.querySelector(".efp-day__track"), items = sec.querySelectorAll(".efp-day__i"), ticking = false;
    function frame() {
      ticking = false;
      if (flat && flat.matches) return;
      var travel = sec.offsetHeight - window.innerHeight;
      if (travel <= 0) return;
      var p = Math.min(1, Math.max(0, -sec.getBoundingClientRect().top / travel));
      track.style.setProperty("--day-p", (Math.min(1, p / 0.6) * 100).toFixed(1) + "%");
      for (var i = 0; i < items.length; i++) items[i].classList.toggle("is-day", p >= 0.15 * (i + 1));
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(frame); } }
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    frame();
  });
})();
